// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"a1e0ee1f","158":"8842164d","217":"1594f327","263":"ce203295","437":"161967cf","453":"eeeba5ed","785":"903e7eb1"}[chunkId] + ".chunk.js";
};